import { flexRender } from '@tanstack/react-table';
import { FaFilter } from 'react-icons/fa6';

import { Button } from '@/components-new/button';
import { ActiveFilter, AddFilterButton, Filter, FilterPanel, FilterPanelContent, FilterPanelContents, FilterPanelSection, FilterPanelSections, FiltersBar, ResetFiltersButton } from '@/components-new/filter';
import { StateFilter, PoolsFilter, PDLStatusFilter, PATypeFilter } from '@/components-new/filters/shared-filters';
import { DrugInfoFilterSchema, useDrugInfoFilters } from '@/features/drugs/hooks/use-drug-info-filters';

// Re-export shared filters with proper typing for this context
export const DrugStateFilter = StateFilter;
export const DrugPoolsFilter = PoolsFilter; 
export const DrugPDLStatusFilter = PDLStatusFilter;
export const DrugPATypeFilter = PATypeFilter;

export const DrugInfoFilters = ({
  filter,
}: { filter: ReturnType<typeof useDrugInfoFilters>['filter'] }) => {
  return (
    <Filter filter={filter}>
      <AddFilterButton as={Button} outline>
        <FaFilter/>
        Add Filter
      </AddFilterButton>
      <FilterPanel>
        <FilterPanelSections>
          {filter.resolvedFilterSections.map(section => (
            <FilterPanelSection key={section.id}>
              {flexRender(section.sectionLabel, section.getContext())}
            </FilterPanelSection>
          ))}
        </FilterPanelSections>
        <FilterPanelContents>
          {filter.resolvedFilterSections.map(section => (
            <FilterPanelContent key={section.id}>
              {flexRender(section.sectionContent, section.getContext())}
            </FilterPanelContent>
          ))}
        </FilterPanelContents>
      </FilterPanel>
      <FiltersBar>
        {filter.values.map(value => {
          const section = filter.getSection(value.key)!;

          return (
            <ActiveFilter
              key={value.key}
              onClick={() => filter.setSelectedSection(value.key)}
              onDismiss={() => filter.removeFilterValue(value.key)}
            >
              {flexRender(section.filterLabel, section.getContext())}
            </ActiveFilter>
          );
        })}
        {filter.values.length > 0 && (
          <ResetFiltersButton onClick={filter.clearFilterValue}>
            Reset Filters
          </ResetFiltersButton>
        )}
        {
          filter.values.length === 0 && (
            <>No active filters</>
          )
        }
      </FiltersBar>
    </Filter>
  );
};
